import * as angular from 'angular';

class RatingStarsComponent {
    static $inject = ['$scope', '$translate'];

    starsCount;
    rating: number;
    showLabel: boolean = true;

    constructor(
        protected $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService
    ) { }
}

angular.module('naut').component('ratingStars', {
    template: require('./rating-stars.component.html'),
    controller: RatingStarsComponent,
    controllerAs: 'vm',
    bindings: {
        'rating': '<',
        'showLabel': '<',
        'starsCount': '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/staffRating/components/rating-stars/rating-stars.component.ts